<template>
  <el-badge
    :value="count > 0 ? count : ''"
    :max="100"
    class="item"
    title="消息提醒"
  >
    <slot></slot>
  </el-badge>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["user"]),
    count: function() {
      return this.user.notification_count + this.user.message_count;
    }
  }
};
</script>
